/** Reading SQL well enough to know which words name the data model. */

/** Tables the query reads, taken from its FROM and JOIN clauses. */
export function tablesInQuery(query: string): string[] {
  const found = new Set<string>();
  const pattern = /\b(?:from|join)\s+([a-z_][a-z0-9_]*)/gi;
  let match = pattern.exec(query);
  while (match !== null) {
    found.add(match[1].toLowerCase());
    match = pattern.exec(query);
  }
  return [...found];
}

export interface SqlToken {
  /** Stable across renders: where the token starts in the query. */
  key: string;
  text: string;
  /** Identifiers are candidates for a provenance lookup; punctuation is not. */
  isIdentifier: boolean;
}

/**
 * The query split into identifiers and the text between them, so it can be
 * re-rendered character-for-character with some words made interactive.
 */
export function tokenizeQuery(query: string): SqlToken[] {
  const parts = query.split(/([A-Za-z_][A-Za-z0-9_]*)/);
  let offset = 0;
  return parts.map((text, index) => {
    const token: SqlToken = {
      key: `${offset}:${text}`,
      text,
      // split() with one capture group alternates: separator, capture, ...
      isIdentifier: index % 2 === 1,
    };
    offset += text.length;
    return token;
  });
}
